export default __webpack_public_path__ + "static/graphik-medium-web-a450d9ba00e9c6e4f0f27c17efb112c6.woff";